import { useEffect, useRef } from 'react';
import { useOfficialStore } from '$/store/useOfficialStore';
import { useLanguageStore } from '$/store/languageStore';
import { useCommonStore } from '@/store/useCommonStore';
import { getEnv, navigate } from '@/common/agents';
import { getMyIpPaths } from '@/utils/myIp/routes';

/** 等待真实登录初始化，并将账号/空间/服务端隔离为独立请求上下文。 */
export function useMyIpSession() {
  const initialized = useCommonStore((state) => state.initialized);
  const sdkInitialized = useOfficialStore((state) => state.isInitComponent);
  const uid = useOfficialStore((state) => state.userInfo.uid);
  const clientId = useOfficialStore((state) => state.clientId);
  const clientOId = useOfficialStore((state) => state.clientOId);
  const oversea = useOfficialStore((state) => state.isOverseaServer);
  const locale = useLanguageStore((state) => state.languageStore.languageCode);
  const ready = initialized && sdkInitialized;
  const paths = getMyIpPaths(getEnv().ENV === 'development');
  return {
    ready,
    locale,
    userId: uid,
    enabled: ready && Boolean(uid),
    scopeKey: JSON.stringify([uid, clientOId ?? 0, clientId, oversea]),
    paths,
  };
}

/** 未登录或资格被服务端撤回时 replace 首页；同步隐藏由数据 hook 保证。 */
export function useMyIpHomeRedirect(redirect: boolean, home: string, scopeKey: string) {
  const redirected = useRef<string>();
  useEffect(() => {
    if (!redirect) { redirected.current = undefined; return; }
    const key = JSON.stringify([home, scopeKey]);
    if (redirected.current === key) return;
    redirected.current = key;
    navigate({ mode: 'url', url: home, replace: true });
  }, [redirect, home, scopeKey]);
}
